import React, { ForwardedRef, useEffect, useImperativeHandle, useState } from "react";

import { ReactIcons } from "@kalyzee/escaet-ui";

export interface MeetingPlayerSoundEffectOverlayProps {
  enabled?: boolean;
  top?: boolean;
  left?: boolean;
  right?: boolean;
  bottom?: boolean;
  icon?: boolean;
  color?: string;
  width?: number;
}

export interface MeetingPlayerSoundEffectOverlayRef {
  update: (props: Partial<MeetingPlayerSoundEffectOverlayProps>) => void;
}

const MeetingPlayerSoundEffectOverlay = React.forwardRef(
  (
    { enabled = false, top = true, left = true, right = true, bottom = true, icon = true, color = "#0090FF", width = 3 }: MeetingPlayerSoundEffectOverlayProps,
    forwardRef: ForwardedRef<MeetingPlayerSoundEffectOverlayRef>
  ) => {
    const [data, setData] = useState<MeetingPlayerSoundEffectOverlayProps>({
      enabled,
      top,
      left,
      right,
      bottom,
      icon,
      color,
      width,
    });

    // ---------------------------------------------------------------------- //
    // ---------------------------  UTILS ----------------------------- //
    // ---------------------------------------------------------------------- //

    // ---------------------------------------------------------------------- //
    // ---------------------------  EFFECTS ----------------------------- //
    // ---------------------------------------------------------------------- //

    useImperativeHandle(
      forwardRef,
      () => ({
        update: (newProps) => {
          setData(Object.assign({}, data, newProps));
        },
      }),
      []
    );

    useEffect(() => {
      setData((curr) => ({
        enabled: enabled ?? curr.enabled,
        top: top ?? curr.top,
        left: left ?? curr.left,
        right: right ?? curr.right,
        bottom: bottom ?? curr.bottom,
        icon: icon ?? curr.icon,
        color: color ?? curr.color,
        width: width ?? curr.width,
      }));
    }, [enabled, top, left, right, bottom, icon, color, width]);

    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    if (!data.enabled) return null;
    return (
      <>
        {data.top ? <div style={{ position: "absolute", top: 0, left: 0, width: data.width, height: "100%", backgroundColor: data.color }} /> : null}
        {data.left ? <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: data.width, backgroundColor: data.color }} /> : null}
        {data.right ? <div style={{ position: "absolute", top: 0, right: 0, width: data.width, height: "100%", backgroundColor: data.color }} /> : null}
        {data.bottom ? <div style={{ position: "absolute", bottom: 0, right: 0, width: "100%", height: data.width, backgroundColor: data.color }} /> : null}
        {data.icon ? (
          <ReactIcons.SoundIndicator
            style={{
              position: "absolute",
              top: 10,
              left: 10,
              width: 32,
              height: 32,
              color: data.color,
            }}
          />
        ) : null}
      </>
    );
  }
);

export default MeetingPlayerSoundEffectOverlay;
